import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// Inter est servie par l'application elle-même (paquet local), pas par un CDN :
// l'outil doit démarrer sur un réseau fermé, et une police qui n'arrive pas
// décale toute la mise en page. Les sous-ensembles non latins ne sont
// téléchargés que si une page en contient — l'unicode-range s'en charge.
import '@fontsource-variable/inter/wght.css';
import App from './App';
import './index.scss';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
